export default __webpack_public_path__ + "static/media/chat.0f309dbf.svg";